import { MouseEvent, useState } from 'react';
import useWidth from '../../../../../../components/Hooks/useWidth';
import useProductDetailsMedias from '../../../hooks/useProductDetailsMedias';

const useProductMediaColorSelector = () => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | null>(null);
  const { mobileWidth } = useWidth();
  const { colors, selectedProductColorId, selectMediaColor } = useProductDetailsMedias();

  const colorsWithMedias = colors.filter((color) => color.medias.length > 0);

  const closeSelector = () => setAnchorElement(null);

  const openSelector = (event: MouseEvent<HTMLElement>) => setAnchorElement(event.currentTarget);

  const handleSelectColor = (productColorId: string) => {
    closeSelector();
    selectMediaColor(productColorId);
  };

  return {
    colors,
    anchorElement,
    isOpen: !!anchorElement,
    openSelector,
    closeSelector,
    handleSelectColor,
    canSelectMediaColor: !mobileWidth && colorsWithMedias.length > 1,
    selectedColor: colors.find((color) => color.productColorId === selectedProductColorId),
  };
};

export default useProductMediaColorSelector;
